import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IncrediLegend } from 'incredi-ui';

import COLORS from '@/design-system/colors.json';
import { AgentStatus } from '@/views/agents/components/agents-table/types/agents-table.types';

type AgentStatusMap = AgentStatus | 'Online';

export default /*#__PURE__*/_defineComponent({
  __name: 'agent-status-legend',
  props: {
    value: null
  },
  setup(__props: any) {

const STATUS_COLOR_MAP: Record<AgentStatusMap, string> = {
  Downloading: COLORS['Hovers/hover_grey'], // TODO: not in use - might be removed
  Helping: COLORS['Status/status_helping'],
  Initiating: COLORS['Status/status_busy'],
  Installing: COLORS['Hovers/hover_grey'], // TODO: not in use - might be removed
  Offline: `${COLORS['System/app_disabled']}40`,
  Ready: COLORS['Status/status_ready'],
  Online: COLORS['Status/status_ready'], // Online is used for Linux ready status
  Updating: COLORS['System/app_info'],
  Incompatible: COLORS['System/app_error'],
  Duplicate: COLORS['System/app_error'],
  Stopped: `${COLORS['System/app_disabled']}40`,
  Expired: COLORS['System/app_error'],
};



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IncrediLegend), {
    color: STATUS_COLOR_MAP[__props.value as keyof typeof STATUS_COLOR_MAP],
    size: 8,
    class: _normalizeClass([{ bordered: __props.value === 'Stopped' }, "min-w-[8px]"])
  }, null, 8, ["color", "class"]))
}
}

})